import React from 'react'
import { Link, useLocation } from 'react-router-dom';

let NavLinks = [ 
    {
        name:"Home",
        link:"/" 
    },
    {
        name:"About",
        link:"/about"
    },
    {
        name:"Locations",
        link:"/location"

    },
    {
        name:"Shop",
        link:"/shop"
    }, 
]; 

export default function NavItems() {   

  const pathName = useLocation().pathname;
  
  const navItems = NavLinks.map((link, index)=>{ 
    return(
      <li className={`${pathName === link.link ? "current-page" : ""}`} key={index}>
        <Link to={link.link} >{link.name}</Link>
      </li>
    )
  });
  return (
    <ul className='navbar-nav'>
      {navItems}
    </ul> 
  )
}
